import { orderConfirmationAccountSignUpMessageStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationAccountSignUpMessage";
import { orderConfirmationBillingInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationBillingInformation";
import { headerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationHeader";
import { orderInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationOrderInformation";
import { productListStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationProductList";
import { orderConfirmationShippingInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationShippingInformation";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

headerStyles.continueButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
};

headerStyles.addToListButton = {
    mergeCss: true,
    buttonType: "outline",
    variant: "secondary",
    css: css`
        margin-left: 10px;
    `,
};

headerStyles.narrowOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            button {
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
};

headerStyles.buttonGridItem = {
    css: css`
        justify-content: flex-end;
        align-items: center;
    `,
    width: [2, 2, 2, 6, 6],
};

productListStyles.orderLinesList = {
    wrapper: {
        css: css`
            div[class^="sc"] {
                h3 {
                    display: flex;
                    align-items: center;
                }
                h4 {
                    font-size: 16px !important;
                }
            }
        `,
    },
};

orderConfirmationAccountSignUpMessageStyles.createAccountButton = {
    mergeCss: true,
    css: css`
        margin-left: auto;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        flex: 0 0 auto;
                    `,
                ],
                "min",
            )}
    `,
};

orderInformationStyles.orderNumberGridItem = {
    width: 12,
    css: css`
        margin-bottom: 15px !important;
    `,
};

orderInformationStyles.orderNumberHeading = {
    mergeCss: true,
    variant: "h3",
};

orderInformationStyles.shippingInformationGridItem = {
    width: 12,
    css: css`
        margin-bottom: 15px !important;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    padding: 0px !important;
                `,
                null,
            ])}
    `,
};

orderInformationStyles.salespersonGridItem = {
    width: [6, 6, 6, 3, 3],
    css: css`
        display: none;
    `,
};

orderInformationStyles.shippingInformationGridItem = {
    width: 9,
};

orderConfirmationShippingInformationStyles.shippingInformationTitleGridItem = {
    width: 12,
    css: css`
        margin-bottom: 5px !important;
        display: none;
    `,
};

orderConfirmationShippingInformationStyles.shippingInformationTitle = {
    variant: "h4",
    as: "h2",
    css: css`
        @media print {
            font-size: 15px;
        }
        padding-top: 0;
        margin-bottom: 0;
        font-size: ${TYPOGRAPHY.size.larger} !important;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        font-size: ${TYPOGRAPHY.size.smaller} !important;
                    `,
                ],
                "max",
            )}
    `,
};

orderConfirmationBillingInformationStyles.billingInformationTitleGridItem = {
    width: 12,
    css: css`
        margin-bottom: 5px !important;
        display: none;
    `,
};

orderConfirmationBillingInformationStyles.billingInformationTitle = {
    variant: "h4",
    as: "h2",
    css: css`
        @media print {
            font-size: 15px;
        }
        padding-top: 0;
        margin-bottom: 0;
        font-size: ${TYPOGRAPHY.size.larger} !important;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        font-size: ${TYPOGRAPHY.size.smaller} !important;
                    `,
                ],
                "max",
            )}
    `,
};

headerStyles.buttonGridItem = {
    width: [2, 2, 2, 6, 6],
    css: css`
        justify-content: flex-end;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    padding: 7px !important;
                `,
            ])}
    `,
};

orderInformationStyles.billingInformationGridItem = {
    width: 12,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    padding: 0px !important;
                `,
                null,
            ])}
    `,
};
